var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476-80q-81.91 0-153.96-31Q250-142 196-196t-85-126.04Q80-394.09 80-476q0-83.36 31.5-156.68Q143-706 197-760.95q54-54.94 127-87Q397-880 480-880t156 32.05q73 32.06 127 87 54 54.95 85.5 128.27Q880-559.36 880-476v314q0 33.82-24.09 57.91Q831.83-80 798-80H476Zm0-65q140 0 240-96.2Q816-337.39 816-476q0-143-97.65-243.5T480-820q-143 0-241.5 100.5T140-476q0 29.18 5 57.09Q150-391 159-365l162-162 132 112 154-155h-77v-60h180v180h-60v-77L456-334 324-446 186-308q44 74 120.5 118.5T476-145Zm322.5 12q12.5 0 21-9t8.5-21.5q0-12.5-9-21t-21-8.5q-12 0-21 8.62-9 8.63-9 21.38 0 12 9 21t21.5 9ZM465-483Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.a39451834087b5f7427219c88cf5a8ea.svg";
export { ForwardRef as ReactComponent };